import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { UserDetails, UserDetailsInput } from '../types';
import { db } from './authService';

export const getUserDetails = async (userId: string): Promise<UserDetails | null> => {
  const snapshot = await getDoc(doc(db, 'users', userId));
  return snapshot.exists() ? snapshot.data() as UserDetails : null;
};

export const saveUserDetails = async (
  userId: string,
  details: UserDetailsInput,
): Promise<UserDetails> => {
  const sanitized: UserDetailsInput = {
    firstName: details.firstName.trim(),
    lastName: details.lastName.trim(),
    organization: details.organization.trim(),
    city: details.city.trim(),
    whatsapp: details.whatsapp.trim(),
    practiceAreas: details.practiceAreas,
  };

  const payload = {
    ...sanitized,
    profileCompletedAt: serverTimestamp(),
    profileUpdatedAt: serverTimestamp(),
  };

  await setDoc(doc(db, 'users', userId), payload, { merge: true });
  return sanitized;
};
